export const APP_VERSION = 'db13670';
